import { LayoutServiceData } from '@sitecore-jss/sitecore-jss-nextjs';
import { SitecoreIds } from 'lib/constants/sitecore-ids';
import { Condition } from 'lib/rules/types';
import { GetStaticPropsContext } from 'next';
import { Plugin } from '..';

class PageAffiliatePlugin implements Plugin {
  conditionId = SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.PageAffiliate.ItemId;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async exec(condition: Condition, _context: GetStaticPropsContext, layout: LayoutServiceData) {
    //@ts-ignore allow for extra condition properties
    condition.pageAffiliateId = layout?.sitecore?.context?.pageAffiliateId;

    return condition;
  }
}

export const pageAffiliatePlugin = new PageAffiliatePlugin();
